export const amount = (value: number, withoutSymbol = false): string => {
  if (value === null || value === undefined) {
    return ''
  }
  const format = Math.ceil(value)
    .toString()
    .split('')
    .reverse()
    .join('')
  const convert = format.match(/\d{1,3}/g) || []
  const num = convert
    .join('.')
    .split('')
    .reverse()
    .join('')
  return withoutSymbol ? num : 'Rp ' + num
}
